import type { SxProps, Theme } from '@mui/material';

const BORDER_COLOR = '#a4adbe';
const FOCUS_BORDER_COLOR = '#3788e6';

const outlinedInputBorderStyles = {
  '& fieldset': {
    borderColor: BORDER_COLOR,
  },
  '&:hover fieldset': {
    borderColor: BORDER_COLOR,
  },
  '&.Mui-focused fieldset': {
    borderColor: FOCUS_BORDER_COLOR,
  },
};

export const integrationFieldLabelSx: SxProps<Theme> = {
  fontSize: '12px',
  marginBottom: '8px',
  color: 'rgba(27, 61, 85, 0.6)',
};

export const integrationAutocompleteSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    ...outlinedInputBorderStyles,
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
  },
  '& .MuiInputBase-input::placeholder': {
    color: BORDER_COLOR,
    opacity: 1,
  },
};

export const integrationSelectSx: SxProps<Theme> = {
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: BORDER_COLOR,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: BORDER_COLOR,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: FOCUS_BORDER_COLOR,
  },
  '& .MuiSelect-select': {
    padding: '12px 16px',
  },
};

export const integrationTextareaSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    padding: '8px 12px',
    ...outlinedInputBorderStyles,
  },
  '& .MuiInputBase-input': {
    padding: 0,
    fontSize: '16px',
    lineHeight: 1.5,
    letterSpacing: '-0.16px',
    '&::placeholder': {
      color: BORDER_COLOR,
      opacity: 1,
    },
  },
};


